import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4axqt8gtu: FaireProductEntity = {
  token: "p_b4axqt8gtu",
  type: "product",
  name: "LE GRAND TOPANGA",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/b99ba2b59a479e090fc386d9ca7b5023bb52e6cee0dff875cee9e4162989f919.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d77c1eddbf7dc8261236f5e61ab0d67d92fe369adb38e4df2490e4ed87ba09c.jpeg",
    "https://cdn.faire.com/fastly/915d9f5aa992e45ecd7f9e8d1feb99adf32e06436a7cd643ff61a9b441a7df0a.jpeg",
    "https://cdn.faire.com/fastly/c2a7ee79d4192f1857666a0ed2319956f0864f3e5fdca09b39b9f225a794a1c8.jpeg",
    "https://cdn.faire.com/fastly/13364a267447a08816e11c9e0f3ff4dd61b2d6b563ec8fe345980f716ad26a61.jpeg"
  ],
  priceDollars: 30,
  description: "Le Grand Topanga, 14 oz of your favorite scent!\n\nA fresh, earthy scent inspired by the untamed nature of Topanga Canyon. Perched between Malibu and Calabasas, this unfettered land is rife with wild sage, lavender, cedar and pine. Softened with top notes of fig, lily and fresh green leaves and grounded with undertones of fir, patchouli and sweet incense.\n\ngreen leaves, wild sage, fig, lavender, fir, cedar, incense\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:10.817Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
